import { render, staticRenderFns } from "./order-info.vue?vue&type=template&id=0dd4559d&scoped=true"
import script from "./order-info.vue?vue&type=script&lang=js"
export * from "./order-info.vue?vue&type=script&lang=js"
import style0 from "./order-info.vue?vue&type=style&index=0&id=0dd4559d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4559d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd4559d')) {
      api.createRecord('0dd4559d', component.options)
    } else {
      api.reload('0dd4559d', component.options)
    }
    module.hot.accept("./order-info.vue?vue&type=template&id=0dd4559d&scoped=true", function () {
      api.rerender('0dd4559d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/ferry/order-info.vue"
export default component.exports